module.exports = [
  {
    element: "div",
    className: "spriteInputContainer",
    children: [
      {
        element: "span",
        className: "selectedSpriteLabel",
        textContent: "Name:",
      },
      {
        element: "input",
        className: "selectedSpriteInput",
        value: "Library",
        gid: "libraryNameInput",
      },
    ],
  },
];
